import { gql } from '@apollo/client'

export const Query = gql`
  query Assets(
    $companyId: ID!,
    $filters: AssetFilters,
    $order: AssetOrder,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    assets(
      companyId: $companyId,
      filters: $filters,
      order: $order,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        barcode {
          id
          barcode
        }
        serialNumber
        warehouse {
          id
          name
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
